"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_style_singleton_1 = require("react-style-singleton");
var medium_1 = require("./medium");
var Style = react_style_singleton_1.styleSingleton();
var styles = "\n [" + medium_1.focusHiddenMarker + "] {\n   pointer-events: none !important;\n }\n";
exports.InteractivityDisabler = function () { return React.createElement(Style, { styles: styles }); };



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es5/InteractivityDisabler.js
// module id = 668
// module chunks = 0